<div class="bigBannerTerritories">
  <p-galleria [value]="images" [showIndicators]="true" [showIndicatorsOnItem]="true" [showThumbnailNavigators]="false"
    [showThumbnails]="false" [containerStyle]="{ width: '100%' }">
    <ng-template pTemplate="item" let-itema>
      <div class="image-container">
        <img [src]="itema.itemImageSrc" class="gallery-image" />
        <div class="territoryName font-semibold">
          <i class="pi pi-arrow-left"></i> {{ territoryName }}
        </div>
      </div>
    </ng-template>
  </p-galleria>
</div>


<main class="site-content px-6">
  <div class="unselectable container">
   <div class="flex justify-content-between align-items-center pt-4 mb-4">
    <div class="territory-region text-xl font-bold"> 
      <i class="pi pi-map-marker"></i>
      {{ territoryName }}</div>
    <div class="territory-number-experiences text-xl">
      {{experienceNum}}+ Esperienze
    </div>
   </div> 
   <p-divider layout="horizontal" />
   <div class="flex justify-content-between">
    <div class="territory-description">
      <h2 class="text-2xl">Scopri il territorio vinicolo di {{ territoryName }}</h2>
      <p class="text-lg" [innerHTML]="territoryDescription"></p>
    </div>
    <div class="territory-map mt-2">
     <img style="width:195px;" src="assets/images/mappa-italia-toscana.png"/>
    </div>
   </div> 
<section class="wineRegionExperiences relative mt-6">
  <header class="flex justify-content-between align-items-center pt-4 mb-4">
    <h2 class="mt-3 text-2xl mb-0">Esperienze in questo territorio vinicolo</h2>
    <div class="territory-number-experiences text-xl">
      {{experienceNum}}+ Esperienze
    </div>
  </header>

  <div>
    <p-carousel [value]="experiences" [numVisible]="4" [numScroll]="1"
    [responsiveOptions]="responsiveOptionsExperience">
    <ng-template let-exp pTemplate="item">
      <app-experience-card [experience]="exp" (click)="linkToExperience(exp.id, exp.title)"></app-experience-card>
    </ng-template>
  </p-carousel>
  </div>
  <div class="text-center">
    <p-button class="divineaBodyButton no-underline inline-block mt-3 pl-6 pr-6 font-bold" href="">
      Scopri tutte
    </p-button>
  </div>
</section>
<section class="RegionExperiences relative mt-6">
  <header class="flex justify-content-between align-items-center pt-4 mb-4">
    <h2 class="mt-3 text-2xl mb-0">Altre esperienze in questa regione</h2>
    <div class="territory-number-experiences text-xl">
      {{experienceNum}}+ Esperienze
    </div>
  </header>
  <div>
    <p-carousel [value]="experiences" [numVisible]="4" [numScroll]="1"
    [responsiveOptions]="responsiveOptionsExperience">
    <ng-template let-exp pTemplate="item">
      <app-experience-card [experience]="exp" (click)="linkToExperience(exp.id, exp.title)"></app-experience-card>
    </ng-template>
  </p-carousel>
  </div>
  <div class="text-center">
    <p-button class="divineaBodyButton no-underline inline-block mt-3 pl-6 pr-6 font-bold" href="">
      Scopri tutte
    </p-button>
  </div>
</section>
<section class="WineRegionWineries relative mt-6">
  <header class="flex justify-content-between align-items-center pt-4 mb-4">
    <h2 class="mt-3 text-2xl mb-0">Scopri le principali cantine di questo territorio vinicolo</h2>
    <div class="territory-number-experiences text-xl">
      {{experienceNum}}+ cantine
    </div>
  </header>
  <div>
    <p-carousel [value]="companies" [numVisible]="3" [numScroll]="1"
    [responsiveOptions]="responsiveOptionsExperience">
    <ng-template let-cmp pTemplate="item">
      <app-winery-card [wineryCompany]="cmp"></app-winery-card>
    </ng-template>
  </p-carousel>
  </div>
  <div class="text-center">
    <p-button class="divineaBodyButton no-underline inline-block mt-3 pl-6 pr-6 font-bold" href="">
      Scopri tutte
    </p-button>
  </div>
</section>

<section class="WineRegionWineries relative mt-6 mb-5 pb-5">
  <header class="flex justify-content-between align-items-center pt-4 mb-4">
    <h2 class="mt-3 text-2xl mb-0">Scopri la regione {{ region }} e i suoi territori vinicoli</h2>
    <div class="territory-number-experiences text-xl">
      {{experienceNum}}+ cantine
    </div>
  </header>
  <div>
    <p-carousel [value]="experiences" [numVisible]="4" [numScroll]="1"
    [responsiveOptions]="responsiveOptionsExperience">
    <ng-template let-exp pTemplate="item">
      <app-experience-card [experience]="exp" (click)="linkToExperience(exp.id, exp.title)"></app-experience-card>
    </ng-template>
  </p-carousel>
  </div>
</section>
</div>
</main>